<template>
	<div class="content__column content__column--small">
		<h1 class="content__title">Lista de opciones de envío gratis</h1>
		<div class="results" v-if="options">
			<div class="results__element" v-for="(option, index) in options" :key="index">
				<div class="results__info">
					<h2 class="results__title" v-text="option.name"></h2>
					<p class="results__text" v-text="option.title_es"></p>
					<p class="results__text">{{option.country_es}}<span v-if="option.state_id"> - {{option.state}}</span></p>
					<p class="results__text">Estatus: {{ option.status_id | optionStatus}}</p>
				</div>
				<div class="results__actions">
					<button @click.prevent="$parent.$emit('view', option.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--view">
						Ver Opción
					</button>
					<button @click.prevent="$parent.$emit('edit', option.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--edit">
						Editar Opción
					</button>
					<button @click.prevent="deleteOption(option.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--delete">
						Borrar Opción
					</button>
				</div>
			</div>
		</div>
		<div class="information" v-else>
			<p class="information__text">No se encontraron resultados</p>
		</div>
		<confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
	</div>
</template>

<script>
	import httpService from '@/core/api/request'
	import OptionMixins from './mixins'
	import confirmation from '@/components/layout/confirmation'
	export default {
		props: {
			filters: {
				type: String,
				required: false,
				default: function() {
					return ''
				}
			}
		},
		mixins: [httpService, OptionMixins],
		components: { confirmation },
		data: function() {
			return {
				optionId: null,
				options: null,
				confirm: false
			}
		},
		created: function() {
			this.getOptions()
		},
		mounted: function() {
			this.$on('continue', () => {
				this.confirm = false
				this.proccedToDelete()
			})
		},
		watch: {
			filters: function() {
				this.getOptions()
			},
			'$store.state.elementChanged': {
				handler: function() {
					this.getOptions()
				},
				deep: true
			}
		},
		methods: {
			getOptions: function() {
				let httpRequest = {
					params: '?' + this.filters,
					module: 'free_shipping'
				}
				this.get(httpRequest)
					.then(options => {
						this.options = options.data
					})
					.catch(() => {
						this.options = null
					})
			},
			deleteOption: function(id) {
				this.confirm = true
				this.optionId = id
			},
			proccedToDelete: function() {
				let httpRequest = {
					params: '',
					module: 'free_shipping'
				}
				this.delete(this.optionId, httpRequest)
					.then(response => {
						this.getOptions()
						this.$store.commit('notificate', {
							title: 'OPCIÓN BORRADA',
							text: 'La opción ha sido borrada correctamente',
							type: 'success'
						})
					})
					.catch(error => {
						this.$store.commit('notificate', {
							title: 'OPCIÓN NO BORRADA',
							text: 'No se pudo borrar la opción seleccionada, por favor intente más tarde',
							type: 'warn'
						})
					}) 
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/free_shipping/list.vue